/* eslint-disable no-loops/no-loops */
/* eslint-disable spellcheck/spell-checker */
import React from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import Content from './Content'
import via0 from './assets/VIA0.png'
import ami_fr from './assets/ami_fr.png'
import ami_en from './assets/ami_en.png'
import ami_de from './assets/ami_de.png'
import ami_ch from './assets/ami_ch.png'
import ami_ja from './assets/ami_ja.png'
import ami_pl from './assets/ami_pl.png'
import ami_pt from './assets/ami_pt.png'
import ami_tr from './assets/ami_tr.png'
import ami_es from './assets/ami_es.png'
import ami_Canada from './assets/ami_Canada.png'
import boing from './assets/boing.png'
import { api } from '../index.api'
import { callAnalyticsLink, wrapAnalyticsLinks } from '../../helpers/analytics'
import { PERMISSIONS } from '../../constants'
import { setAssistantActive } from '../../actions/assistant'
import { isAssistantPathEnabled } from '../../pages/functions'
import { getCookie } from '../../helpers/CookieHandler'

import {
  ANALYTICS_LINK_TYPES,
  ANALYTICS_LINK_SECTIONS
} from '../../constants'

const LANDING_SELECTION = { value: 'Landing' }

const initialState = {
  minimized: false,
  showAssistant: false,
  showDialog: false,
  isLoading: false,
  blah: false,

  selection: LANDING_SELECTION,

  // array of arrays of questions pertaining to category
  questions: null,
  // determines current index of questions
  currentPage: 0
}
var countrySelected ='';
var affiliateSelected ='';
var userLanguage = '';

class BotAssistant extends React.Component {
  constructor (props) {
    super(props)
    // content language is always English when constructor resolves, but gets updated by componentWillReceiveProps
    this.content = this.props.pageContent.content.module.digitalAssistant
    this.state = initialState

    // keeps track of sequence of selections for breadcrumb nav
    this.selections = []

    // initial variable to determine whether assistant should be enabled
    this.assistantEnabled = false

    // set by API responses
    this.products = null
    this.categories = null
  }

  // getAMIImageName =() => {
  //   let imageSrc = "./assets/ami_"+getCookie('welcomeLanguage')+".png"
  //   return <img src={imageSrc} alt="Ami" />
  // };

  // getAmiIconImage(icon) {
  //   let imageSrc = "./assets/ami_"+getCookie('welcomeLanguage')+".png"
  //   switch (icon) {
  //     case imageSrc === './assets/ami_fr.png': return ami_fr;
  //     case imageSrc === './assets/ami_en.png': return ami_en;
  //     case imageSrc === './assets/ami_es.png': return ami_es;
  //     default: break
  //   }
  // }

  handleBoing = () => {
    this.selections = []
    this.setState(prevState =>
      prevState.minimized
        ? {
          minimized: false,
          showDialog: false,
          selection: LANDING_SELECTION,
          questions: null,
          currentPage: 0
        }
        : {
          minimized: true
        }
    )
  };

  openFromExternalComponent = () => {
    if (this.state.isLoading || this.state.showDialog) {
      return
    }

    if (this.state.minimized) {
      this.selections = []
      this.setState({
        minimized: false,
        showDialog: true,
        selection: LANDING_SELECTION,
        questions: null,
        currentPage: 0
      })
    } else {
      this.setState({ showDialog: true })
    }
  }

  handleBack = () => {
    this.selections.pop()
    if (this.selections.length === 0) {
      this.setState({ selection: LANDING_SELECTION })
    } else {
      const selection = this.selections[this.selections.length - 1]
      this.setState({ selection })
      this.handleChoice(selection)
    }
  };

  handleHome = () => {
    this.selections = []
    this.setState({ selection: LANDING_SELECTION, questions: null })
  };

  handleClose = () => {
    this.setState({ showDialog: false })
  };

  handleOpen = () => {
    callAnalyticsLink(
      ANALYTICS_LINK_TYPES.CUSTOM_LINK,
      ANALYTICS_LINK_SECTIONS.ASSISTANT + 'Open Ami',
      'assistant'
    )
    this.setState({ showDialog: true })
  };

  handleClick = choice => {
    if (choice) {
      this.handleChoice(choice)
      this.selections.push(choice)
      this.setState({ selection: choice })
    }
  };

  handleChoice = choice => {
    if (choice.content) {
      return
    }

    // case where product is selected
    if (choice.name && choice.productCode) {
      this.setState({ isLoading: true })

      api.getAssistantCategories(
        { productCode: choice.productCode,
          country: this.countrySelected,
          affiliate : this.affiliateSelected },
        response => {
          this.categories = response
          this.setState({ isLoading: false })
        },
        error => {
          throw error
        }
      )
    }

    // case where category is selected
    if (choice.id || choice.categoryId) {
      this.setState({ isLoading: true })
      let queryParams
      if (choice.categoryId && choice.affiliate) {
        // initial question
        queryParams = {
          productCode: choice.productCode,
          categoryId: choice.categoryId,
          parentId: choice.id,
          country: this.countrySelected,
          affiliate : this.affiliateSelected,
          userLanguage : this.userLanguage // added for fetching category based on affiliate// added for fetching category based on affiliate
        }
      } else if (choice.id) {
        // subsequent questions
        queryParams = {
          productCode: this.selections[2].productCode,
          categoryId: choice.id,
          country: this.countrySelected,
          affiliate : this.affiliateSelected,
          userLanguage : this.userLanguage // added for fetching category based on affiliate
        }
      }
      api.getAssistantQuestions(
        queryParams,
        response => {
          const questions = this.paginate(response)
          this.setState({ currentPage: 0, questions })
          this.setState({ isLoading: false })
        },
        error => {
          throw error
        }
      )
    }
  };

  handleNav = index => {
    if (typeof index === 'undefined') {
      this.handleHome()
      return
    }
    this.selections = this.selections.slice(0, index + 1)
    if (this.selections.length === 0) {
      this.setState({ selection: LANDING_SELECTION })
    } else {
      const selection = this.selections[this.selections.length - 1]
      this.setState({ selection })
      this.handleChoice(selection)
    }
  };

  handlePageForward = () => {
    this.setState(prevState => ({
      currentPage:
        prevState.currentPage === this.state.questions.length - 1
          ? prevState.currentPage
          : prevState.currentPage + 1
    }))
  };

  handlePageBackward = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage === 0 ? 0 : prevState.currentPage - 1
    }))
  };

  handlePageNav = currentPage => {
    this.setState({ currentPage })
  };

  // hide/show Assistant based on available window size
  componentDidMount () {
    window.addEventListener('resize', this.checkDimensions.bind(this))
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.checkDimensions.bind(this))
  }

  componentDidUpdate () {
    wrapAnalyticsLinks('.assistant-container', 'assistant')
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.referenceData) {
      return
    }
    const referenceData = nextProps.referenceData.referenceData
    const assistantContent = nextProps.pageContent.content.module.digitalAssistant
    this.countrySelected = referenceData.SelectedCountry.name
    this.affiliateSelected = referenceData.SelectedCountry.affiliate
    this.userLanguage = getCookie('welcomeLanguage');
    if (
      assistantContent && nextProps.permissions.indexOf(PERMISSIONS.ASSISTANT) !== -1
    ) {
      this.assistantEnabled = isAssistantPathEnabled()
      const deviceSizeAllowed = document.documentElement.clientWidth > 700
      if (this.assistantEnabled && deviceSizeAllowed) {
        this.content = assistantContent
        this.setState({ showAssistant: true })
        this.props.setAssistantActive(true)
      }
      api.getAssistantProducts(
        referenceData.SelectedCountry.affiliate,
        referenceData.SelectedCountry.name,
        response => {
          const products = []
          for (const i in response) {
            const product = {
              name: response[i].name,
              productCode: response[i].productCode,
              veevaProductCode: response[i].veevaProductCode
            }
            products.push(product)
          }
          this.products = products
        },
        error => {
          throw error
        }
      )
    }
  }

  checkDimensions = () => {
    if (document.documentElement.clientWidth < 700) {
      this.setState({ showAssistant: false })
      this.props.setAssistantActive(false)
    } else {
      this.setState({ showAssistant: this.assistantEnabled })
      this.props.setAssistantActive(this.assistantEnabled)
    }
  };

  paginate = questions => {
    if (questions.length <= 4) {
      return [questions]
    }
    const sortedQuestions = []
    let intermediateArr = []
    let i = 0
    for (const idx in questions) {
      intermediateArr.push(questions[idx])
      if (i === 3) {
        sortedQuestions.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    sortedQuestions.push(intermediateArr)
    return sortedQuestions
  };

  render () {
    const userType = this.props.referenceData ? this.props.referenceData.referenceData.UserType : null
    let imageSrc = "./assets/ami_"+getCookie('welcomeLanguage')+".png"
    let imageCountry = "./assets/ami_"+getCookie('welcomeCountryLabel')+".png"
    let tempImage
    if (imageSrc === './assets/ami_fr.png') {
      tempImage = ami_fr
    } else if (imageSrc === './assets/ami_en.png' && imageCountry === './assets/ami_Canada.png') {
      tempImage = ami_Canada
    } else {
      tempImage = ami_en
    }
    // Use Below code for AMI images for different languages
    //let imageSrc = "./assets/ami_"+getCookie('welcomeLanguage')+".png"
    // switch (imageSrc) {
    //   case (imageSrc === './assets/ami_fr.png'):
    //     tempImage = ami_fr
    //     break
    //   case (imageSrc === './assets/ami_en.png'):
    //     tempImage = ami_en
    //     break
    //   case (imageSrc === './assets/ami_es.png'):
    //     tempImage = ami_es
    //     break
    //   case (imageSrc === './assets/ami_ch.png'):
    //     tempImage = ami_ch
    //     break
    //   case (imageSrc === './assets/ami_de.png'):
    //     tempImage = ami_de
    //     break
    //   case (imageSrc === './assets/ami_ja.png'):
    //     tempImage = ami_ja
    //     break
    //   case (imageSrc === './assets/ami_pl.png'):
    //     tempImage = ami_pl
    //     break
    //   case (imageSrc === './assets/ami_pt.png'):
    //     tempImage = ami_pt
    //     break
    //   case (imageSrc === './assets/ami_tr.png'):
    //     tempImage = ami_tr
    //     break
    //   default:
    // }
    return this.state.showAssistant ? (
      <div className='assistant-container'>
        <div className='assistant-toggle'>
          <span
            id='hidAmi'
            className={`fa fa-close fa-lg toggle-minimize ${
              this.state.minimized ? 'hidden' : ''
            }`}
            onClick={this.handleBoing}
          />
          {<img
            id = 'assistantButton'
            className={`toggle-image ${this.state.minimized ? 'hidden' : ''}`}
            src={tempImage}
            alt='Ami'
            onClick={this.handleOpen}
          />}
          {/* { <img
            id = 'assistantButton'
            className={`toggle-image ${this.state.minimized ? 'hidden' : ''}`}
            src={via0}
            alt='Ami'
            onClick={this.handleOpen}
          /> } */}
          <img
            className={`boing ${!this.state.minimized ? 'hidden' : ''}`}
            src={boing}
            alt='Boing'
            onClick={this.handleBoing}
          />
        </div>
        <div
          className={
            this.state.showDialog
              ? 'assistant-window show-assistant'
              : 'assistant-window'
          }
        >
          <Header
            title={this.content.header.summary}
            onClose={this.handleClose}
            onBack={this.handleBack}
            onHome={this.handleHome}
          />
          {this.state.isLoading ? (
            <div />
          ) : (
            <Content
              onClick={this.handleClick}
              onNav={this.handleNav}
              onPageNav={this.handlePageNav}
              onPageBackward={this.handlePageBackward}
              onPageForward={this.handlePageForward}
              currentPage={this.state.currentPage}
              questions={this.state.questions}
              selection={this.state.selection}
              categories={this.categories}
              products={this.products}
              selections={this.selections}
              content={this.content}
              patientContent={this.props.pageContent.content.page.HOME.patient}
              permissions={this.props.permissions}
              userType={userType}
              landingSelectionValue={LANDING_SELECTION.value}
            />
          )}
        </div>
      </div>
    ) : null
  }
}

function Header (props) {
  return (
    <div className='assistant-header'>
      <div className='assistant-title'>
        {props.title}
        <div className='assistant-nav'>
          <span
            id='navHome'
            className='fa fa-fast-backward fa-lg'
            onClick={props.onHome}
          />
          <span id= 'navBack' className='fa fa-backward fa-lg' onClick={props.onBack} />
          <span id='closeAmi' className='fa fa-close fa-lg' onClick={props.onClose} />
        </div>
      </div>
    </div>
  )
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent,
    permissions: state.permissions,
    referenceData: state.referenceData.filter(function (item) {
      return item.type === 'REF_DATA'
    })[0]
  }
}

export default connect(mapStateToProps, { setAssistantActive }, null, { withRef: true })(BotAssistant)



// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/BotAssistant.js